import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { canUseFleetUI, FleetRoles } from "../../auth/fleetRoles";

function IsPrivate({ children, allowedRoles = null }) {
  const { isLoggedIn, isLoading, fleetRole } = useContext(AuthContext);
  const { t } = useTranslation();

  // If the authentication is still loading
  if (isLoading) return <p>{t("common.loading", { defaultValue: "Loading..." })}</p>;

  if (!isLoggedIn) {
    // If the user is not logged in
    return <Navigate to="/login" />;
  }

  if (!canUseFleetUI(fleetRole)) {
    return <Navigate to="/no-access" replace />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !allowedRoles.includes(fleetRole)) {
    if (fleetRole === FleetRoles.MAINTENANCE) {
      return <Navigate to="/maintenance" replace />;
    }
    if (fleetRole === FleetRoles.HHRR) {
      return <Navigate to="/drivers" replace />;
    }
    if (fleetRole === FleetRoles.OPERATIONS || fleetRole === FleetRoles.EXECUTIVE || fleetRole === FleetRoles.OWNER) {
      return <Navigate to="/welcome" replace />;
    }
    return <Navigate to="/no-access" replace />;
  }

  if (fleetRole === FleetRoles.MAINTENANCE && (!Array.isArray(allowedRoles) || allowedRoles.length === 0)) {
    return <Navigate to="/maintenance" replace />;
  }

  return children;
}
export default IsPrivate;
